import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "@mui/material";

import ChatScreen from "../../components/adminChat";
import useTranslation from "../../hooks/Translation";

const ManageChats = () => {
  const t = useTranslation();
  return (
    <div>
      <div className="main_layout">
        <div className="dashboard">
          <h1 className="mn_heading">{t.sideBar.manageChats}</h1>
        </div>
        <Card className="cards">
          <ChatScreen />
        </Card>
      </div>
    </div>
  );
};

export default ManageChats;
